module.exports = __webpack_public_path__ + "img/people.5a5f57a8.png";